import React,{Component} from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Col,
} from "shards-react";

import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../firebase';
import AddFees from './AddFees'; 


export default class DisplayFeeDetails extends Component{

  constructor(props) {
    super(props);
  
    this.state = {
                  date:undefined,
                  dateobject:null,
                  loading:false,
                  fees_paid:undefined,
                  total_fee:undefined,
                };

    this.setDate = this.setDate.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.get_fee_details = this.get_fee_details.bind(this);
    this.update_fee_details = this.update_fee_details.bind(this);
  }

  setDate=(date)=>{
        var dd = (date.getDate()).toString();
        var mm = (date.getMonth()+1).toString();
        var yyyy = (date.getFullYear()).toString();
        
        
        if(dd.length===1){
            dd = '0' + dd;
        }
        if(mm.length===1){
          mm = '0' + mm;
        }
        if(yyyy.length===1){
           yyyy = '0' + yyyy;
        }
        var format  = dd+"/"+mm+"/"+yyyy;
        this.setState({date:format});
  }

   handleDateChange(value) {
        this.setState({dateobject:new Date(value)})
        this.setDate(new Date(value));
    }

  componentDidMount(){
    this.handleDateChange(new Date());
  }


  update_fee_details =()=>{
      if(this.props.selected_student===undefined || this.state.fees_paid===undefined || this.state.total_fee===undefined || this.state.date===undefined){
          toast("Insuficient Detials",{containerId:'A'});
          console.log(this.state);
          return;
      }

      var that = this;
      this.setState({loading:true});
      var code = this.props.selected_student.class+":"+this.props.selected_student.roll_no;
        
      var data = {
          class:this.props.selected_student.class,
          roll_no:this.props.selected_student.roll_no,
          name:this.props.selected_student.name,
          fees_paid:parseInt(this.state.fees_paid),
          total_fee :parseInt(this.state.total_fee),
          last_date:this.state.date,
      }

      firebase.firestore().collection('Fees').doc(code).set(data).then(function(doc){
            toast('Fees Succesfully Updated !', {containerId: 'A'});
            that.setState({loading:false});
      }).catch(function(err){
            console.log(err);
            toast(err.message, {containerId: 'A'});
            that.setState({loading:false});
      })

  }


  get_fee_details = ()=>{

      var that = this;

      if(this.props.selected_student===undefined){
          toast('No Student Selected !', {containerId: 'A'});
          return;
      }

      this.setState({loading:true,fees_paid:0,total_fee:0});
      var code = this.props.selected_student.class+":"+this.props.selected_student.roll_no;

      firebase.firestore().collection('Fees').doc(code).get().then(function(doc){
          if(!doc.exists){
              that.setState({loading:false});
          }
          else{
              var data = doc.data();
              that.setState({fees_paid:data.fees_paid,total_fee:data.total_fee,date:data.last_date,loading:false});
          }
      }).catch(function(err){
          console.log(err);
          that.setState({loading:false});
          toast(err.message,{containerID:'A'});
      })

  }

   componentDidUpdate(prevProps) {
       
    if(this.props.selected_student!==undefined){

        if(prevProps.selected_student!==undefined){
          
           if (this.props.selected_student.class !== prevProps.selected_student.class) {
                console.log("Class Changed");
                this.get_fee_details();  
            }
            
            else if(this.props.selected_student.roll_no!== prevProps.selected_student.roll_no){
                console.log("Roll no changed");
                this.get_fee_details();
            }

        }
        else{
          console.log(this.props.selected_student);
          this.get_fee_details();
        }
        
        

    } 
  }

  render(){
    
    



    return(
      <Card small className="mb-4">
    <CardHeader className="border-bottom">
      <h6 className="m-0">Fees Details</h6>
    </CardHeader>

    
    <CardBody className="pt-0"> 

    { (!this.state.loading && !(this.props.selected_student===undefined) )&&

        <AddFees selected_student={this.props.selected_student} 
                  fees_paid = {this.state.fees_paid}
                  total_fee = {this.state.total_fee}
                  date = {this.state.date}
                  setFeePaid={(value)=>{this.setState({fees_paid:value})}}
                  setTotalFee={(value)=>{this.setState({total_fee:value})}}
                  handleDateChange ={this.handleDateChange}
                  update_fee_details={this.update_fee_details}
            />

  }
  


                    {//No student info ui below
                    }

                  { (!this.state.loading && (this.props.selected_student===undefined)) &&
                    <Col className="mb-0" lg="12" style={{marginTop: '2%'}}>
                   <div style={{margin: '20%'}} className="text-muted">
                        <div  style={{fontSize:55,textAlign: 'center'}}>
                            <i class="material-icons">error_outline</i>
                        </div>
                        <div  style={{fontSize:25,textAlign: 'center'}}>
                          {"Select the Student"}
                        </div>  
                                              
                  
                  </div>
                  </Col>  
                  }


                  {
                        (this.state.loading) &&
                          <div style={{margin: '10%',marginLeft: '40%'}}>
                              <AtomSpinner color="blue" />            
                          </div>
                  }   
            

    </CardBody>
  </Card>
)
  }
}

